module.exports = __webpack_public_path__ + "img/0a3317bb9ba0f09e955dc5cf21f8fb7e.png";